var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDebtIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgexport-6_4_",
    "data-name": "svgexport-6 (4)",
    xmlns: "http://www.w3.org/2000/svg",
    height: "2.01rem",
    viewBox: "0 0 32.259 32.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11774",
    "data-name": "Group 11774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3909",
    "data-name": "Path 3909",
    d: "M129.009,95.2V90.945a.945.945,0,0,0-1.89,0V95.2a2.834,2.834,0,0,0-1.613,3.894l-3.011,3.011a.945.945,0,0,0,1.337,1.337l3.011-3.011a2.835,2.835,0,1,0,2.167-5.231Zm-.945,3.618a.945.945,0,1,1,.945-.945A.946.946,0,0,1,128.064,98.821Z",
    transform: "translate(-114.518 -84.329)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3910",
    "data-name": "Path 3910",
    d: "M347.462,304.228l-.282-.1v-1.894a1.057,1.057,0,0,1,.191.12.774.774,0,0,0,.531.206.787.787,0,0,0,.534-1.366,2.825,2.825,0,0,0-1.255-.622v-.283a.788.788,0,1,0-1.575,0v.335l-.046.013a2.386,2.386,0,0,0-1.638,1.87,2.132,2.132,0,0,0,.709,2.1,4.971,4.971,0,0,0,.975.578v2.643a2.139,2.139,0,0,1-.724-.343.788.788,0,1,0-.862,1.318,3.408,3.408,0,0,0,1.586.618v.319a.788.788,0,1,0,1.575,0v-.4a2.863,2.863,0,0,0,2-2.254A2.525,2.525,0,0,0,347.462,304.228Zm-1.857-.862,0,0a.6.6,0,0,1-.133-.568.992.992,0,0,1,.136-.341Zm2.02,3.459a1.3,1.3,0,0,1-.445.772v-1.772a.933.933,0,0,1,.445,1Z",
    transform: "translate(-322.009 -280.63)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3911",
    "data-name": "Path 3911",
    d: "M26.686,16.851a13.537,13.537,0,1,0-9.834,9.834,7.876,7.876,0,1,0,9.834-9.834ZM16.52,24.817a11.6,11.6,0,0,1-2.028.345v-.905a.945.945,0,0,0-1.89,0v.907A11.606,11.606,0,0,1,6,22.425l.637-.637A.945.945,0,0,0,5.3,20.452l-.637.637a11.605,11.605,0,0,1-2.739-6.6h.907a.945.945,0,1,0,0-1.89H1.929A11.606,11.606,0,0,1,4.667,6l.637.637A.945.945,0,0,0,6.641,5.3L6,4.667a11.605,11.605,0,0,1,6.6-2.739v.907a.945.945,0,1,0,1.89,0V1.929a11.606,11.606,0,0,1,6.6,2.739l-.637.637a.945.945,0,0,0,1.337,1.337L22.425,6a11.606,11.606,0,0,1,2.739,6.6h-.907a.945.945,0,0,0,0,1.89h.905a11.606,11.606,0,0,1-.345,2.028q-.216-.012-.434-.012a7.885,7.885,0,0,0-7.876,7.876Q16.508,24.6,16.52,24.817Zm7.864,5.552a5.986,5.986,0,1,1,5.986-5.986A5.992,5.992,0,0,1,24.383,30.369Z",
    fill: "#199b8b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebtIcon);
export default __webpack_public_path__ + "static/media/debt-icon.65fbb727557db143e5c473840a0745dd.svg";
export { ForwardRef as ReactComponent };